<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程名称" prop="name"><el-input v-model="formParameter.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="年份" prop="year"><el-input v-model="formParameter.year" autocomplete="off"
                  maxlength="4"></el-input></el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item label="版本号" prop="version"><el-input v-model="formParameter.version"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="天数" prop="version"><el-input v-model="formParameter.days"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="类型" prop="type"><select-option-dictionary v-model="formParameter.type"
                dkey="course-type" ></select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="小标题" prop="remk"><el-input v-model="formParameter.remk"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
          <el-col :span="8" >
            <el-form-item label="状态" prop="state">
              <el-select v-model="formParameter.state"   >
                <el-option v-for="itm in [{ idx: 1, nm: '在用' }, { idx: 2, nm: '停用' }]" :key="itm.idx" :label="itm.nm"
                  :value="itm.idx"></el-option>
              </el-select>
              </el-form-item>
          </el-col>
          <el-col :span="8" v-if="formParameter.type > 3">
            <el-form-item label="售价(分)" prop="price"><el-input v-model="formParameter.price"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" v-if="formParameter.type != 5">
            <el-form-item label="科目选项" prop="sid">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0"></div>
              <el-checkbox-group v-model="selectedSubs" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="sb in formParameterAll" :label="sb.id" :key="sb.id">{{ sb.name }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-show="formParameter.type > 3">
          <el-col :span="24">
            <wang-edit ref="wedt" v-model="formParameter.details" autocomplete="off">
            </wang-edit>
          </el-col>
        </el-row>

        <el-row v-if="formParameter.type > 3">
          <el-col :span="24">
            <el-form-item label="图片地址" prop="imageUrl"><el-input v-model="formParameter.imageUrl"
                autocomplete="off"></el-input></el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formParameter.type == 4">
          <el-col :span="12">
            <el-form-item label="精选推介" prop="type">
              <el-checkbox v-model="isJinxuan">精选题库</el-checkbox>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="精选排序" v-if="isJinxuan" prop="popIdx"><el-input v-model="formParameter.popIdx"
                autocomplete="off" :disabled="isDisabled"></el-input></el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formParameter.type > 3 && formParameter.imageUrl">
          <el-col :span="24">
            <img style="width: 300px;height: 220px;" :src="baseUrl + formParameter.imageUrl" />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>

import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/edu/course/course.js";
import wangEdit from '@/components/wangEdit/wangEdit.vue';
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import constant from "@/util/constant.js";

export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary, wangEdit
  },
  data() {
    return {
      checkAll: false,
      selectedSubs: [],
      isIndeterminate: false,
      baseUrl: constant.serverUrl,
      formParameterAll: {},
      checkedCities: {},
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      isDisabled:false,

      isJinxuan: false, //是否精选

      parameter: {},
      formParameter: {},
      rules: {
        name: [
          {
            validator: this.$validate.required,
            trigger: "blur"
          }
        ],
        //年份
        year: [
          {
            validator: this.$validate.required,
            trigger: "blur",
          },
          {
            validator: this.$validate.length,
            min: 4,
            max: 4,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
   
    handleCheckAllChange(val) {
      let array = [];
      for (let j of this.formParameterAll) {
        array.push(j.id);
      }
      this.selectedSubs = val ? array : [];

      this.checkAll = val ? true : false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.formParameterAll.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.formParameterAll.length;
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, size);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.isJinxuan = false;
      this.disabled = false;
      this.$refs.popup.close();
    }, submitForm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        this.formParameter.sid = "";

        //不是刷题课程
        if (this.formParameter.type != 5) {
          this.selectedSubs.forEach((v, i) => {
            this.formParameter.sid += v;
            if (i + 1 < this.selectedSubs.length) {
              this.formParameter.sid += ",";
            }
          });
        }
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);

          api.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          if (!this.isJinxuan) {
            delete this.formParameter.popIdx
          }
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });

    },

    //提交表单
    confirm() {

      //判断能不能加精
      if (this.formParameter.type == 4) {

        if (this.formParameter.popIdx) {
          api.jjIdxInuse({ id: this.parameter.id, popIdx: this.formParameter.popIdx }, (res) => {
            this.submitForm()
          }, err => {
            this.$utils.msg.warning(err.msg);
          })
        } else {
          this.submitForm()
        }

      } else {
        this.submitForm()
      }
 
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.id) {
        //编辑查询数据
        let parameter = {
          id: this.parameter.id,
        };
        api.toUpdate(parameter, (response) => {
          this.formParameter = response.data.course;
          this.formParameterAll = response.data.subjectsAll;
          this.selectedSubs = response.data.subjects;

            if(this.formParameter.type*1>3 && this.formParameter.details){
              this.$refs.wedt.init(this.formParameter.details);
            } 
       

          this.popupLoading = false;
          this.formParameter.id = this.parameter.id;
          if (this.formParameter.popIdx) {
            this.isJinxuan = true;
          }
        });
      } else {
        api.toSave({}, (response) => {
          this.formParameterAll = response.data.subjectsAll;
        });
        //添加
        this.popupLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
